import {
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
    SERVER_URL,
} from '../constants/api';
import {
    headersAuthReceiveJson, headersAuthSendReceiveJson
} from '../../store/headers';
import { apiHandleResponse } from '../../util/api';

const getPartnerIpMasks = () => {
    return fetch(`${SERVER_URL}/api/v2/client/partneripmask`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};


const createIpMask = (payload) => {
    return fetch(`${SERVER_URL}/api/v2/client/partneripmask`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

const updatePartnerMask = (client) => {
    return fetch(`${SERVER_URL}/api/v2/client/partneripmask`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

export {
  
    createIpMask,
    getPartnerIpMasks,
    updatePartnerMask
};